import React, { useState, useEffect } from "react";
import axios from "axios";

import { useParams, Link as Links } from 'react-router-dom';
//다국어 지원


// reactstrap components
import {
  Container,
  Row,
  Col,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Button
} from "reactstrap";

//Language Dropdown
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";

// logo
import logo from '../../assets/img/intospace_logo_light.png';


import { useTranslation } from 'react-i18next';



export default function MainNavbar() {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [collapseOut, setCollapseOut] = useState("");
  const [color, setColor] = useState("navbar-transparent");

  const [loggedIn, setLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [roleCheck, setRoleCheck] = useState();

  // 모바일 여부 감지 (991px 이하)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  const { param } = useParams();

  useEffect(() => {
    window.addEventListener("scroll", changeColor);

    // 화면 크기 변경 감지
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    window.addEventListener("resize", handleResize);

    return function cleanup() {
      window.removeEventListener("scroll", changeColor);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // /get-session 엔드포인트를 호출하여 로그인 상태 확인
    axios.defaults.withCredentials = true
    axios.get( '/get-session', {
        baseURL : process.env.REACT_APP_SERVER_URL,
        },{
          withCredentials: true
        })
      .then((response) => {

        const getSessionRequestData = response.data;

        if (getSessionRequestData.success) {
          setLoggedIn(true);
          setUserInfo(getSessionRequestData.userInfo);
          setRoleCheck(getSessionRequestData.userInfo.role);
          //return navigate("/");
        } else {
          setLoggedIn(false);
          setUserInfo(false);
          //alert("세션이 만료되었습니다. 다시 로그인 하세요.");
        }
      })
      .catch((error) => {
        //console.error('로그인 상태 확인 실패:', error);
        setLoggedIn(false);
        setUserInfo(false);
      });

  }, [loggedIn]); //loggedIn 상태가 변경될 때


  const { t, i18n } = useTranslation();
  // localStorage에서 언어 상태를 불러오고, 없으면 'ko'로 초기화
  const getInitialLang = () => {
    return localStorage.getItem('lang') || 'ko';
  };
  const [currentLang, setCurrentLang] = useState(getInitialLang());

  // 언어 변경 함수
  const changeLanguage = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem('lang', lang);
    i18n.changeLanguage(lang).then(() => {
      // 언어 변경 성공
    }).catch(err => {
      // 언어 변경 실패
    });
  };

  // 언어 상태가 변경될 때마다 i18n.changeLanguage 호출
  useEffect(() => {
    i18n.changeLanguage(currentLang);
  }, [currentLang]);


  const changeColor = () => {

    const element = document.getElementsByClassName('register-page')[0];

    // className을 확인하고 조건을 검사합니다.
    if (element && element.className.includes('register-page')) {
        if (
          document.documentElement.scrollTop > 19 ||
          document.body.scrollTop > 19
        ) {
          setColor("bg-intospace-main");
        } else if (
          document.documentElement.scrollTop < 20 ||
          document.body.scrollTop < 20
        ) {
          setColor("navbar-transparent");
        }
    } else {
        if (
          document.documentElement.scrollTop > 99 ||
          document.body.scrollTop > 99
        ) {
          setColor("bg-intospace-main");
        } else if (
          document.documentElement.scrollTop < 100 ||
          document.body.scrollTop < 100
        ) {
          setColor("navbar-transparent");
        }
    }
  };

  const toggleCollapse = () => {
    document.documentElement.classList.toggle("nav-open");
    setCollapseOpen(!collapseOpen);
  };
  const onCollapseExiting = () => {
    setCollapseOut("collapsing-out");
  };
  const onCollapseExited = () => {
    setCollapseOut("");
  };

  // Link 클릭 시에 Alert 창 띄우기
  /*
    const handleLinkClick = () => {
      alert('서비스 준비 중입니다');
    };
  */

 

  /* Navbar dropdown */
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpen3, setDropdownOpen3] = useState(false);
  const [dropdownOpen4, setDropdownOpen4] = useState(false);
  const [dropdownOpen5, setDropdownOpen5] = useState(false);

  const toggleDropdown1 = () => {
    setDropdownOpen1((prevState) => !prevState);
  };
  const toggleDropdown2 = () => {
    setDropdownOpen2((prevState) => !prevState);
  };
  const toggleDropdown3 = () => {
    setDropdownOpen3((prevState) => !prevState);
  };
  const toggleDropdown4 = () => {
    setDropdownOpen4((prevState) => !prevState);
  };
  const toggleDropdown5 = () => {
    setDropdownOpen5((prevState) => !prevState);
  };

  // useEffect(() => {
  //   if(param !== undefined){

  //     //Board와 같이 숫자가 파라미터로 넘어오는 경우는 자동 스크롤 기능 제외(Home, LoneSmart만 적용)

  //     //npm build를 위해 대체코드 작성
  //     // const paramToString =  param.replaceAll(/[\d]/gi,"").length;
  //     const paramToString = param.replace(/\d+/g, "").length;

  //     if(paramToString > 0){
  //       const scrollToSection = () => {
  //         const anchor = document.querySelector('#'+param)
  //         anchor.scrollIntoView({ behavior: 'smooth', block: 'start' })
  //         /*
  //         window.scrollTo(param, { duration : 500, smooth: true })
  //         */
  //       }
  
  //       return (
  //         scrollToSection()
  //       );
  //     }

  //   }
  // }, [param]);
  useEffect(() => {
    const scrollToSection = () => {
      const anchor = document.getElementById(param); // Changed from querySelector to getElementById for clarity
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.error('Element not found:', param);
      }
    };
  
    if (param) {
      const paramToString = param.replace(/\d+/g, "").length;
      if (paramToString > 0) {
        scrollToSection();
      }
    }
  }, [param]);

  // fade Animation
  useEffect(() => {
    const options = {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0,  // 50%가 viewport에 들어와 있어야 callback 실행
    }

    let introObserver = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {
        //console.log("entry : " + entry) // e : 현재 감시 중인 모든 div 박스가 출력됨
        // 감시 중인 box가 등장 & 퇴장 시 실행됨 => 이중으로 동작함

        // 화면에 보일 때만 style을 변경하고 싶을 때는
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        } else {
          entry.target.classList.remove('active');
        }
      });
    }, options);

    const target = document.querySelectorAll('.fadeDivide');

    target.forEach(el => {
      introObserver.observe(el);
    });
  }, []);

  return (
    <Navbar className={"fixed-top " + color} color-on-scroll="80">
      <Container>
        <div className="navbar-static">
          <NavbarBrand to="/" id="navbar-brand" tag={Links}>
            <img className="navbar logo" alt="logo_intospace" src={logo} />
          </NavbarBrand>
          <div className="navbar-btn">

                {loggedIn && userInfo && (
                    <a href="/Profile">
                      <button className="navbar-toggler">
                        <FontAwesomeIcon icon={faUser} />
                      </button>
                    </a>
                )}
                {!userInfo && (
                    <a href="/Login">
                      <button className="navbar-toggler">
                        <FontAwesomeIcon icon={faUser} />
                      </button>
                    </a>
                )}   
              <button
                aria-expanded={collapseOpen}
                className="navbar-toggler last-icon"
                onClick={toggleCollapse}
              >
                <FontAwesomeIcon icon={faBars} />
              </button>
          </div>
        </div>

        <Collapse
          className={collapseOut}
          navbar
          isOpen={collapseOpen}
          onExiting={onCollapseExiting}
          onExited={onCollapseExited}
        >
          <div className="navbar-collapse-header">
            <Row>
              <Col className="collapse-brand">
                <a href="/" onClick={(e) => e.preventDefault()}>
                </a>
              </Col>
              <Col className="collapse-close text-right">
                <button
                  aria-expanded={collapseOpen}
                  className="navbar-toggler xMark"
                  onClick={toggleCollapse}
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </Col>
            </Row>
          </div>

          <Nav navbar> {/* navbar-nav */}
            <div className="mainLink">
              <NavItem className="p-0">
                <UncontrolledDropdown
                  className="mainNavDropdown"
                  onMouseOver={isMobile ? undefined : toggleDropdown1}
                  onMouseOut={isMobile ? undefined : toggleDropdown1}
                  isOpen={isMobile ? false : dropdownOpen1}
                >
                      <DropdownToggle>
                        <NavLink
                          data-placement="bottom"
                          tag={Links}
                          to="/Home"
                          title="Home / 회사소개"
                        >
                          {t('Introduction')}
                        </NavLink>
                      </DropdownToggle>
                      <DropdownMenu id="Dropdown1">
                        <Links
                          to="/Home/IntoMessage"
                          title="Introduce"
                        >
                            <DropdownItem>
                                Introduce
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/Home/Introduce"
                          title="Introduce"
                        >
                            <DropdownItem>
                                Technology
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/Home/Business"
                          title="Business"
                        >
                            <DropdownItem>
                                Business
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/Home/Service"
                          title="Service"
                        >
                            <DropdownItem>
                                Service
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/Home/History"
                          title="History"
                        >
                            <DropdownItem>
                                History
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/Home/Partners"
                          title="Partners"
                        >
                            <DropdownItem>
                                Partners
                            </DropdownItem>
                        </Links>
                      </DropdownMenu>
                  </UncontrolledDropdown>
              </NavItem>

              <NavItem className="p-0">
                <UncontrolledDropdown
                  className="mainNavDropdown"
                  onMouseOver={isMobile ? undefined : toggleDropdown2}
                  onMouseOut={isMobile ? undefined : toggleDropdown2}
                  isOpen={isMobile ? false : dropdownOpen2}
                >
                      <DropdownToggle>
                        <NavLink
                          data-placement="bottom"
                          tag={Links}
                          to="/LoneSmart"
                          title="LONE-Smart"
                        >
                          {t('GNSS Service')}
                        </NavLink>
                      </DropdownToggle>
                      <DropdownMenu id="Dropdown2">
                        <Links
                          to="/LoneSmart/Overview"
                          title="Overview"
                        >
                            <DropdownItem>
                                Overview
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/LoneSmart/Technology"
                          title="Technology"
                        >
                            <DropdownItem>
                                Technology
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/LoneSmart/Features"
                          title="Features"
                        >
                            <DropdownItem>
                                Features
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/LoneSmart/LocationProvider"
                          title="LocationProviderAPI"
                        >
                            <DropdownItem>
                            Location Provider API
                            </DropdownItem>
                        </Links>
                      </DropdownMenu>
                  </UncontrolledDropdown>
              </NavItem>

              <NavItem className="p-0">
                <UncontrolledDropdown
                  className="mainNavDropdown"
                  onMouseOver={isMobile ? undefined : toggleDropdown3}
                  onMouseOut={isMobile ? undefined : toggleDropdown3}
                  isOpen={isMobile ? false : dropdownOpen3}
                >
                      <DropdownToggle>
                        <NavLink
                          data-placement="bottom"
                          tag={Links}
                          to="/SubWAVE"
                          title={t('TNS')}
                          //nClick={handleLinkClick}
                        > {/* Link 임시 차단 / Link 클릭 시에 handleLinkClick 함수 실행 */}
                          {t('TNS')}
                        </NavLink>
                      </DropdownToggle>
                      <DropdownMenu id="Dropdown3">
                        <Links
                          to="/SubWAVE/Overview_SubWAVE"
                          title="Overview"
                        >
                            <DropdownItem>
                                Overview
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/SubWAVE/Installation"
                          title="Installation"
                        >
                            <DropdownItem>
                                Installation
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/SubWAVE/Technology_SubWAVE"
                          title="Technology"
                        >
                            <DropdownItem>
                                Technology
                            </DropdownItem>
                        </Links>
                        {/* <Links
                          to="/SubWAVE/Features_SubWAVE"
                          title="Features"
                        >
                            <DropdownItem>
                                Features
                            </DropdownItem>
                        </Links> */}
                      </DropdownMenu>
                  </UncontrolledDropdown>
              </NavItem>

              <NavItem className="p-0">
                <UncontrolledDropdown
                  className="mainNavDropdown"
                  onMouseOver={isMobile ? undefined : toggleDropdown4}
                  onMouseOut={isMobile ? undefined : toggleDropdown4}
                  isOpen={isMobile ? false : dropdownOpen4}
                >
                      <DropdownToggle>
                        <NavLink
                          data-placement="bottom"
                          tag={Links}
                          to="/UAM"
                          title={t('UAM')}
                          //onClick={handleLinkClick}
                        > {/* Link 임시 차단 / Link 클릭 시에 handleLinkClick 함수 실행 */}
                          {t('UAM')}
                        </NavLink>
                      </DropdownToggle>
                      <DropdownMenu id="Dropdown4">
                        <Links
                          to="/UAM/Overview_ASTRONAV"
                          title="Overview"
                        >
                            <DropdownItem>
                                Overview
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/UAM/Technology_ASTRONAV"
                          title="Technology"
                        >
                            <DropdownItem>
                                Technology
                            </DropdownItem>
                        </Links>
                        <Links
                          to="/UAM/Features_ASTRONAV"
                          title="Features"
                        >
                            <DropdownItem>
                                Features
                            </DropdownItem>
                        </Links>
                      </DropdownMenu>
                  </UncontrolledDropdown>
              </NavItem>

              <NavItem className="p-0">
                <NavLink
                  data-placement="bottom"
                  tag={Links}
                  to="/Contact"
                  title="Contact / 서비스문의"
                  // onClick={handleLinkClick}
                > {/* Link 임시 차단 / Link 클릭 시에 handleLinkClick 함수 실행 */}
                  {t('Service Inquiry')}
                </NavLink>
              </NavItem>
              
              <NavItem className="p-0">
                <NavLink
                  data-placement="bottom"
                  tag={Links}
                  to="/Board"
                  title="Board / 자료실"
                  //onClick={handleLinkClick}
                > {/* Link 임시 차단 / Link 클릭 시에 handleLinkClick 함수 실행 */}
                  {t('Download')}
                </NavLink>
              </NavItem>

              <NavItem className="p-0">
                <NavLink
                  data-placement="bottom"
                  tag={Links}
                  to="/Notice"
                  title="Notice / 공지사항"
                  //onClick={handleLinkClick}
                > {/* Link 임시 차단 / Link 클릭 시에 handleLinkClick 함수 실행 */}
                  {t('Notice')}
                </NavLink>
              </NavItem>
            </div>

            <div className="gnb">
              <NavItem>
                {loggedIn && userInfo && (

                  roleCheck === "admin" ? (
                    <UncontrolledDropdown
                    className="mainNavDropdown"
                    onMouseOver={isMobile ? undefined : toggleDropdown5}
                    onMouseOut={isMobile ? undefined : toggleDropdown5}
                    isOpen={isMobile ? false : dropdownOpen5}
                    >
                        <DropdownToggle>
                          <div className="nav-link nav-profile">
                            <FontAwesomeIcon icon={faUser} /> &nbsp;&nbsp;&nbsp;
                            {userInfo.name}
                          </div>
                        </DropdownToggle>
                        <DropdownMenu id="ProfileDropdown" style={{marginLeft:'-20px'}}>
                          <Links
                            to="/Profile"
                            title="Profile"
                          >
                              <DropdownItem>
                                  Profile
                              </DropdownItem>
                          </Links>
                          <Links
                            to="/UserList"
                            title="UserList"
                          >
                              <DropdownItem>
                                  User Management
                              </DropdownItem>
                          </Links>
                          <Links
                            to="/ContactList"
                            title="Contact"
                          >
                              <DropdownItem>
                                  Contact List
                              </DropdownItem>
                          </Links>
                          <Links
                            to="/ServerState"
                            title="Docker"
                          >
                              <DropdownItem>
                                  Docker Container
                              </DropdownItem>
                          </Links>
                          <Links
                            to="/Setting"
                            title="LONE-Smart"
                          >
                              <DropdownItem>
                                  LONE-Smart Setting
                              </DropdownItem>
                          </Links>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                  ) : (
                    <Links to="/Profile">
                    <div className="nav-link nav-profile">
                      <FontAwesomeIcon icon={faUser} /> &nbsp;&nbsp;&nbsp;
                      {userInfo.name}
                    </div>
                    </Links>
                  )

                )}
                {!userInfo && (
                  <Button
                    className="nav-link"
                    href="/Login"
                  >
                  {t('Login')}
                  </Button>
                )}   
                
              </NavItem>
              <NavItem id="lngDropDown">
                <UncontrolledDropdown>
                    <DropdownToggle caret data-toggle="dropdown">
                        Language
                    </DropdownToggle>
                    <DropdownMenu>
                    <DropdownItem onClick={() => changeLanguage('ko')}>KOREAN</DropdownItem>
                    <DropdownItem onClick={() => changeLanguage('en')}>ENGLISH</DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
              </NavItem>
            </div>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}
